module.exports = __webpack_public_path__ + "img/photo2_4.3f63488e.jpg";